import aclApi from '@/services/acl-api.service'

let loading = null

/** GET /acl/catalog once per page load: the permission keys with their groups, titles and implies */
export const loadCatalog = () => {
  if (!loading) {
    loading = aclApi.catalog().then(res => res.data).catch(e => {
      loading = null
      throw e
    })
  }
  return loading
}

/** Permissions a role may hold, by group in catalog order: [{ group, permissions: [...] }] */
export const groupsOf = catalog => {
  const groups = []
  catalog.permissions.filter(p => !p.superadminOnly).forEach(p => {
    let group = groups.find(g => g.group === p.group)
    if (!group) {
      group = { group: p.group, permissions: [] }
      groups.push(group)
    }
    group.permissions.push(p)
  })
  return groups
}

export const byKey = catalog => Object.fromEntries(catalog.permissions.map(p => [p.key, p]))

/** `keys` with everything they imply, transitively */
export const withImplied = (catalog, keys) => {
  const index = byKey(catalog)
  const result = new Set()
  const stack = [...keys]
  while (stack.length) {
    const key = stack.pop()
    if (!result.has(key) && index[key]) {
      result.add(key)
      stack.push(...index[key].implies)
    }
  }
  return result
}

/** Every permission that (transitively) implies `key`: unticking `key` unticks them too */
export const dependentsOf = (catalog, key) => catalog.permissions
  .filter(p => p.key !== key && withImplied(catalog, [p.key]).has(key))
  .map(p => p.key)

export const START_MODE_TITLES = {
  all: 'Все старты',
  only: 'Только выбранные',
  except: 'Все, кроме',
}

export const userName = user => [user.surname, user.name].filter(Boolean).join(' ') || `#${user.id}`

/** A Date / ISO string as the value of <input type="datetime-local"> in the browser's time zone; '' when empty */
export const toLocalInput = value => {
  if (!value) return ''
  const d = new Date(value)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** The value of a datetime-local input as an ISO string for the API; null when empty */
export const fromLocalInput = value => (value ? new Date(value).toISOString() : null)

/** «с 19.09 09:00 до 20.09 20:00», «до …», «с …»; '' without a period */
export const periodText = (from, to) => {
  const fmt = v => new Date(v).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
  if (from && to) return `с ${fmt(from)} до ${fmt(to)}`
  if (from) return `с ${fmt(from)}`
  if (to) return `до ${fmt(to)}`
  return ''
}
